var BRIDGE_MODES = {
  NATIVE_TO_ERC: 'NATIVE_TO_ERC',
  ERC_TO_ERC: 'ERC_TO_ERC',
  ERC_TO_NATIVE: 'ERC_TO_NATIVE',
  NATIVE_TO_ERC_V1: 'NATIVE_TO_ERC_V1',
  ARBITRARY_MESSAGE: 'ARBITRARY_MESSAGE'
};
var ERC_TYPES = {
  ERC20: 'ERC20',
  ERC677: 'ERC677'
};
var FEE_MANAGER_MODE = {
  ONE_DIRECTION: 'ONE_DIRECTION',
  BOTH_DIRECTIONS: 'BOTH_DIRECTIONS',
  UNDEFINED: 'UNDEFINED'
};
var ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
module.exports = {
  BRIDGE_MODES: BRIDGE_MODES,
  ERC_TYPES: ERC_TYPES,
  FEE_MANAGER_MODE: FEE_MANAGER_MODE,
  ZERO_ADDRESS: ZERO_ADDRESS
};